<template>
  <div class="addMain">
    <div class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index"
        :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never" style="min-height:auto">
      <div class="cardTop">
        <h1>萤石云账号与萤石云摄像头设备关联（{{ name }}）</h1>
      </div>
      <div class="cardBottom">
        <div class="addIntroduce">
          <h3 v-if="haveAvatar">
            请选择要关联的萤石云摄像头设备。
          </h3>
        </div>
        <el-form ref="addForm" :model="addForm">
          <el-form-item label="关联门禁设备"><br />
            <div class="subheading">
              请点击选择萤石云摄像头设备，支持多选。
            </div>
            <el-button class="addCreationBtn" style="margin-top:10px;" plain @click="addLeadger">添加萤石云摄像头设备</el-button>
            <el-table v-if="tableData.length != 0" v-loading="loading" :data="tableData" style="width: 100%">
              <el-table-column prop="name" label="设备名称"></el-table-column>
              <el-table-column prop="code" label="设备编号"></el-table-column>
              <el-table-column prop="installSite" label="安装位置"></el-table-column>
              <el-table-column prop="categoryCode" label="设备分类"></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" style="padding:0" @click.native.prevent="deleteRow(scope.row.id)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </el-form-item>
          <el-form-item>
            <el-button type="text" @click="$router.history.go(-1)">取消</el-button>
            <el-button type="primary" @click="onSubmit">完成</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 选择设备弹框 -->
    <div class="modal-mask" v-show="maskVisible"></div>
    <div class="deviceSelect changeProject" v-show="selectDevice">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="line-height:32px">选择设备</span>
        </div>
        <div class="textItem">
          <el-row :gutter="24">
            <el-col :span="24" style="padding-left:0;">
              <el-table height="370px" v-loading="loading" :data="deviceTableData" style="width: 100%" ref="multiple"
                @select="select" @select-all="selectAll">
                <el-table-column prop="id" type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="设备名称"></el-table-column>
                <el-table-column prop="code" label="设备编号"></el-table-column>
                <el-table-column prop="installSite" label="安装位置"></el-table-column>

              </el-table>
              <span style="float: right;margin-top: 10px;margin-right: 10px;">
                <span style="line-height: 59px;margin-right: 15px;">已选
                  <i style="font-style: initial;color: #409EFF;">{{
                  selection.length
                }}</i>
                  个</span>
                <el-button type="primary" @click="selectBtn">确 定</el-button>
              </span>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
  import API from "../../api/api";
  export default {
    data() {
      return {
        routeList: this.$route.meta.routeList,
        pointAttr: [],
        pointAttrMain: [],
        transferData: [],
        flag: this.$route.query.flag,
        id: this.$route.query.id, //物业用户id
        name: this.$route.query.name, //物业用户name
        loading: false, //加载条
        total: 0,
        pageSize: 10,
        currentPage: 1,
        initSelectData: [], //全部已选数据
        tableData: [], //列表显示的设备
        cancelData: [], //把已选设备存到这里为了取消按钮使用
        addForm: {},
        haveAvatar: false, //是否上传人脸，上传了人脸的用户才能授权门禁
        /************弹框得字段 **************/
        selection: [], //选中的值
        selectDevice: false, //选择设备弹框
        maskVisible: false, // 弹窗mask显示
        deviceTableData: [], //弹框数据
        deviceSearch: "", //弹窗选择设备的搜索
        treeList: [], //选择设备弹框大类数据
        nodeId: "", //节点id（包括父节点id）
        expansion: [], //选择设备弹框默认展开项
        defaultProps: {
          //tree树状的配置key
          children: "children",
          label: "label",
          id: "id"
        }
      };
    },
    created() {},
    methods: {
      //当页面为编辑状态flag==edit时要获取到当前编辑的信息
      getMage() {
        if (this.flag == "edit") {

          //获取设备数据
          let tableData = [];
          let para = {
            size: 99999,
            currentPage: 1,
            ysTokenId: this.$route.query.id
          };
          API.getDevsByYsTokenId(para).then(res => {
            if (res.code == 1) {
              this.initSelectData = res.data.records;
              this.paging();
              this.total = res.data.total;

            }
          });
        } else {
          return false;
        }
      },
      //获取对应类别全部设备
      getAllDevListByCategoryCode() {
        let para = {
          categoryId: "08389ce682e949a6a77aee46c02aa3f6,05e54a60e4ab4d48b416f46e0bc12ebe",
          ysTokentId: this.id
        };
        API.platformGetYsDeviceListUnRef(para).then(res => {
          if (res.code == 1) {
            this.deviceTableData = res.data;
          }
        })

      },
      //移除设备
      deleteRow(id) {
        this.$confirm("是否确定删除该设备?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            for (let i in this.initSelectData) {
              if (this.initSelectData[i].id == id) {
                this.initSelectData.splice(i, 1)
                this.total = this.initSelectData.length
                this.paging();
              }
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      },
      //手动分页
      paging() {
        this.tableData = this.initSelectData.length > 0 ? this.initSelectData.slice((this.currentPage - 1) * this
          .pageSize, this.currentPage * this.pageSize) : []
      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.paging()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.paging()
      },
      ///****************************弹框功能B***************************************** */
      //添加门禁设备
      addLeadger() {
        this.selectDevice = true;
        this.maskVisible = true;
        this.toSelectDev(); //同步勾选设备列表
      },
      // 关闭选择设备台账弹窗
      cancelVisible() {
        this.maskVisible = false;
        this.selectDevice = false;
      },
      //同步选中设备
      toSelectDev() {
        this.$refs.multiple.clearSelection();
        this.selection = []; //清空选中
        for (let i in this.deviceTableData) {
          for (let j in this.initSelectData) {
            if (this.initSelectData[j].id == this.deviceTableData[i].id) {
              //已选中的设备
              this.$refs.multiple.toggleRowSelection(this.$refs.multiple.data[i], true);
              this.selection.push(this.deviceTableData[i])
            }
          }
        }

      },
      //监听选中的数组
      select(selection, row) {
        this.selection = selection
      },
      //全选功能
      selectAll(selection) {
        if (selection.length != 0) {
          this.selection = [];
          this.selection = selection;
        } else {
          this.selection = [];
        }
      },

      //弹框里面搜索的按钮
      searchBtn() {
        this.getpageList(this.nodeId);
      },
      //选择完设备后
      selectBtn() {
        this.initSelectData = this.selection;
        this.paging();
        this.total = this.selection.length;
        this.cancelVisible();
      },

      ///****************************弹框功能E***************************************** */
      //关联设备
      onSubmit() {
        let para = {
          deviceAccountIds: this.initSelectData.map(function (v) {
            return v.id
          }).join(","),
          ysTokenId: this.id,
        };
        API.saveYsTokenDevice(para).then(res => {
          if (res.code == 1) {
            this.$message({
              message: "关联设备成功",
              type: "success"
            });
            this.$router.go(-1);
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        });
      }
    },
    mounted() {
      this.getMage();
      this.getAllDevListByCategoryCode();
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/ysAccountAssociatedDevice.vue